import { IAdvancedRichText, IInputWidget, WidgetType } from '@framework/engine';
import { IMapPrintImage } from './config/print/MapPrintImage';
import { IMapLayer, MapLayerType } from './layers/MapLayer';

export const WidgetTypeMap = 'map' as WidgetType.Map;

/**
 * Mappa
 */
export interface IMapWidget extends IInputWidget {
  id: string;
  type: WidgetType.Map;
  label?: IAdvancedRichText;
  layout?: IInputWidget['layout'] & { hide?: boolean };
  /** Posizione iniziale della mappa */
  position?: {
    center?: [number, number];
    zoom?: number;
  };
  /** Livelli della mappa (fonti dati a livello grafico) */
  layers?: IMapLayer[];
  /** Tipo di selezione */
  selection: {
    multiple?: boolean;
    shape: MapWidgetSelectionShape;
    hideGeometriesTable?: boolean;
  };
  /** Intersezione con altro layer */
  intersection?: {
    title?: string;
    enabled?: boolean;
    type?: MapLayerType;
    url?: string;
    areaTolerance?: number;
  };
  competence?: {
    enabled?: boolean;
    type?: MapLayerType;
    url?: string;
    propertyName?: string;
  };
  /** Immagini da stampare */
  printImages?: IMapPrintImage[];
}

export enum MapWidgetSelectionShape {
  Point = 'point',
  Polygon = 'polygon',
}
